import {OfferMetaRobots} from "../../constants/offer_meta_robots";
import {IOfferListingSeoRule} from "./constants";

export const createMultiFilterRobotsRule = (isMultiFilter: boolean): IOfferListingSeoRule => ({
    condition: () => isMultiFilter,
    robots: OfferMetaRobots.NOINDEX_FOLLOW
});
import {OfferMetaRobots} from "../../constants/offer_meta_robots";
import {IOfferListingSeoRule} from "./constants";

export const createMultiFilterRobotsRule = (isMultiFilter: boolean): IOfferListingSeoRule => ({
    condition: () => isMultiFilter,
    robots: OfferMetaRobots.NOINDEX_FOLLOW
});
